export default {
  methods: {
    getLabel (label) {
      const locale = this.$i18n.locale
      const labels = this.$store.state.labels

      if (label in labels) {
        return labels[label][locale]
      }

      if (this.$store.state.loading) {
        return ''
      }

      return label
    }
  }
}
